export const ClientBookingClasses = {
  en: {
    'Select a date to see available classes':
      'Select a date to see available classes',
    'No classes available for this date': 'No classes available for this date',
    'Select class': 'Select class',
    spotsLeft_one: '{{count}} spot left',
    spotsLeft_other: '{{count}} spots left',
    // SS-1225 (temporary)
    'Location temporarily unavailable message':
      'Climbing SPACE is temporarily unavailable, you can book at our other locations in Kyiv',
  },
  uk: {
    'Select a date to see available classes':
      'Оберіть дату, щоб побачити доступні класи',
    'No classes available for this date': 'Немає доступних класів на цю дату',
    'Select class': 'Оберіть клас',
    spotsLeft_one: 'залишилось {{count}} місце',
    spotsLeft_few: 'залишилось {{count}} місця',
    spotsLeft_many: 'залишилось {{count}} місць',
    // SS-1225 (temporary)
    'Location temporarily unavailable message':
      'Climbing SPACE тимчасово недоступний, ви можете записатися на інші наші локації в Києві',
  },
};
